import ProjectFinalApprovalPage from "../../shared/project-final-approval/ProjectFinalApprovalPage";

const SolarentOperatorProjectFinalApprovalPage = () => (
  <ProjectFinalApprovalPage source="SolarentOperator" />
);

export default SolarentOperatorProjectFinalApprovalPage;
